import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component, Fragment } from 'react';
import EntityTypes from '../../types/EntityTypes';
import renderMarks from '../utils/renderMarks';
import makeToolbarButton, { BASIC_SELECTION, EXPANDED_SELECTION } from '../utils/makeToolbarButton';
import createStore from '../utils/createStore';
import renderToolbarPrompt from '../utils/renderToolbarPrompt';
import getSelectedText from '../utils/getSelectedText';
import extractThreadIdFromMark from './utils/extractThreadIdFromMark';
import { CommentsEmptyIcon, CommentsIcon } from '../../components/Icons';
import ToolbarPrompt from '../../components/ToolbarPrompt';
import makeKeyboardCommandShortcut from '../utils/makeKeyboardCommandShortcut';
import CommentInline from './components/CommentInline';
import CommentHighlighter from './components/CommentHighlighter';
import './style.css';

function createInputComponent(CommentsEditor) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_Component) {
    _inherits(InputComponent, _Component);

    function InputComponent(props) {
      var _this;

      _classCallCheck(this, InputComponent);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(InputComponent).call(this, props));

      _defineProperty(_assertThisInitialized(_this), "onEditorRef", function (editor) {
        _this.editor = editor;
      });

      _defineProperty(_assertThisInitialized(_this), "onChange", function (content, editorValue) {
        _this.setState({
          editorValue: editorValue
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onDraftChange", function (content) {
        _this.setState({
          threadDraft: content
        });

        if (_this.props.onChange) {
          _this.props.onChange(content);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "submit", function () {
        _this.editor.submit(_this.state.threadDraft);
      });

      _this.state = {
        threadDraft: props.value || '',
        editorValue: null
      };
      return _this;
    }

    _createClass(InputComponent, [{
      key: "render",
      value: function render() {
        return React.createElement(CommentsEditor, Object.assign({
          ref: this.onEditorRef
        }, this.props, {
          value: this.props.value ? this.props.value : undefined,
          containerClassName: "flexbox-grow",
          readOnly: false,
          onDraftChange: this.onDraftChange,
          threadDraft: this.state.threadDraft,
          onChange: this.onChange
        }));
      }
    }]);

    return InputComponent;
  }(Component), _temp;
}

export default function CommentPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator,
      _ref$CommentsEditor = _ref.CommentsEditor,
      CommentsEditor = _ref$CommentsEditor === void 0 ? 'textarea' : _ref$CommentsEditor,
      createThread = _ref.createThread;

  var store = createStore();
  var CommentInlineComponent = decorator(CommentInline);
  var InputComponent = createInputComponent(CommentsEditor);
  var commentDraft = undefined;
  return [{
    commands: {
      addComment: function addComment(editor, id) {
        return editor.addMark({
          type: EntityTypes.COMMENT,
          data: {
            id: id
          }
        });
      }
    }
  }, {
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(Fragment, null, next(), React.createElement(CommentHighlighter, {
        store: store
      }));
    }
  }, renderMarks(_defineProperty({}, EntityTypes.COMMENT, function (props) {
    return React.createElement(CommentInlineComponent, Object.assign({}, props, {
      pluginStore: store
    }));
  })), renderToolbarPrompt(_defineProperty({}, EntityTypes.COMMENT, function (props) {
    var onSubmit = function onSubmit(content, entities) {
      var threadId = createThread({
        content: content,
        entities: entities,
        highlight: getSelectedText(props.editor)
      });
      props.editor.addComment(threadId);
      commentDraft = undefined;
      props.onSubmit();
    };

    return React.createElement(ToolbarPrompt, Object.assign({}, props, {
      icon: CommentsEmptyIcon,
      input: InputComponent,
      placeholder: "Write a comment",
      value: commentDraft,
      onSubmit: onSubmit,
      onChange: function onChange(change) {
        commentDraft = change.value;
      },
      autoSelection: true
    }));
  })), makeToolbarButton(EntityTypes.COMMENT, {
    icon: CommentsIcon,
    title: 'Comment',
    visibility: BASIC_SELECTION | EXPANDED_SELECTION,
    onApply: function onApply(editor) {
      return editor.command('openPrompt', EntityTypes.COMMENT);
    }
  }), makeKeyboardCommandShortcut('mod+alt+m', {
    type: EntityTypes.COMMENT,
    canApply: function canApply(editor) {
      return editor.value.selection.isExpanded;
    },
    command: function command(editor) {
      return editor.command('openPrompt', EntityTypes.COMMENT);
    },
    byKey: false
  })];
}
CommentPlugin.extractThreadIdFromMark = extractThreadIdFromMark;